module.exports = __webpack_public_path__ + "img/acounto_logo-05n.44671253.svg";